import {
  defineComponents,
  defineDesignTokens
} from '@contentful/experiences-sdk-react';

import React from 'react';
import { definedTokens } from './studio.config';
import BoxIcon from '@src/elements/BoxIcon';
import { IconDefinition } from './definitions/icon.definition';

export const components = [
  {
    component: BoxIcon,
    definition: IconDefinition,
    options: { wrapContainer: <div /> }
  }
];

// Register custom components
defineComponents(components);

// Register design tokens
defineDesignTokens(definedTokens);

// Register breakpoints
// defineBreakpoints(breakpoints);

const ExperienceComponentRegistration = () => {
  return <div />;
};

export default ExperienceComponentRegistration;
